import { render, staticRenderFns } from "./v-checkbox-group.vue?vue&type=template&id=559fd482&scoped=true&"
import script from "./v-checkbox-group.vue?vue&type=script&lang=js&"
export * from "./v-checkbox-group.vue?vue&type=script&lang=js&"
import style0 from "./v-checkbox-group.vue?vue&type=style&index=0&id=559fd482&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559fd482",
  null
  
)

export default component.exports